module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00010-fs8.dbd60e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00010-fs8.png
// module id = 164
// module chunks = 0